module.exports = __webpack_public_path__ + "static/media/2H.1b2188a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2H.svg
// module id = 55
// module chunks = 0